const RuntimeTrainerData = require("../../../shared/RuntimeTrainerData");

// Returns a string indicating what jazz and character art to show, or null if
// not enough info is provided. Pass an object with various information,
// whatever you have available. Checks for these in order:
// - result
// - block (with model)
// - blockType (if not character)
// - gradeNumber, chapterIndex, blockIndex
const getType = function(props = {}) {
	const {
		result,
		block,
		blockType,
		gradeNumber,
		chapterIndex,
		blockIndex,
	} = props;
	if (result) {
		return result.styleType;
	} else if (block && block.model) {
		return block.model.blockStyleType;
	} else if (blockType && blockType !== "character") {
		return blockType;
	} else {
		const key = gradeNumber + "," + (chapterIndex + 1) + "," + (blockIndex + 1);
		return RuntimeTrainerData.getBlockBeasts()[key] || null;
	}
};

// Returns a string suitable for inclusion in the srcs for the argyles and
// trays, which are basically colorized versions of each other. Pass an object
// with various information, whatever you have available. Checks for these in
// order:
// - result (if type test)
// - block (with model and blockType test)
// - blockType (if test) and gradeNumber
// - enough info for getType
// - gradeNumber
const getColor = function(props = {}) {
	const {result, block, blockType} = props;
	// gradeNumber can be found from a few different places.
	const gradeNumber =
		props.gradeNumber ||
		(result && result.source.gradeNumber) ||
		(block && block.model && block.model.gradeNumber);
	const gradeColor = "grade" + gradeNumber;
	if (gradeNumber && result && result.styleType === "test") {
		return gradeColor;
	} else if (
		gradeNumber &&
		block &&
		block.model &&
		block.model.blockType === "test"
	) {
		return gradeColor;
	} else if (gradeNumber && blockType && blockType === "test") {
		return gradeColor;
	} else {
		return getType(props) || gradeColor;
	}
};

module.exports = {
	getType,
	getColor,
};
